"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Channel = exports.Language = void 0;
// 语种
var Language;
(function (Language) {
    // 英文
    Language["EN"] = "en";
    // 简体
    Language["SC"] = "sc";
    // 繁体
    Language["TC"] = "tc";
    // 日语
    Language["JP"] = "jp";
    // 泰语
    Language["TH"] = "th";
})(Language || (exports.Language = Language = {}));
// 应用列表
var Channel;
(function (Channel) {
    // 系统分享
    Channel["SYSTEM"] = "system";
    // reddit
    Channel["REDDIT"] = "reddit";
    // fb
    Channel["FACEBOOK"] = "facebook";
    // telegram
    Channel["TELEGRAM"] = "telegram";
    // 小红书
    Channel["XIAOHONGSHU"] = "xiaohongshu";
    // tw
    Channel["TWITTER"] = "twitter";
    // ins
    Channel["INSTAGRAM"] = "instagram";
    // whatsapp
    Channel["WHATSAPP"] = "whatsapp";
    // wxFriend: 微信好友
    Channel["WXFRIEND"] = "wxFriend";
    // wxTimeline: 微信朋友圈
    Channel["WXTIMELINE"] = "wxTimeline";
    // 复制链接
    Channel["COPY"] = "copy";
    // line
    Channel["LINE"] = "line";
})(Channel || (exports.Channel = Channel = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInR5cGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsS0FBSztBQUNMLElBQVksUUFXWDtBQVhELFdBQVksUUFBUTtJQUNoQixLQUFLO0lBQ0wscUJBQVMsQ0FBQTtJQUNULEtBQUs7SUFDTCxxQkFBUyxDQUFBO0lBQ1QsS0FBSztJQUNMLHFCQUFTLENBQUE7SUFDVCxLQUFLO0lBQ0wscUJBQVMsQ0FBQTtJQUNULEtBQUs7SUFDTCxxQkFBUyxDQUFBO0FBQ2IsQ0FBQyxFQVhXLFFBQVEsd0JBQVIsUUFBUSxRQVduQjtBQWVELE9BQU87QUFDUCxJQUFZLE9BeUJYO0FBekJELFdBQVksT0FBTztJQUNmLE9BQU87SUFDUCw0QkFBaUIsQ0FBQTtJQUNqQixTQUFTO0lBQ1QsNEJBQWlCLENBQUE7SUFDakIsS0FBSztJQUNMLGdDQUFxQixDQUFBO0lBQ3JCLFdBQVc7SUFDWCxnQ0FBcUIsQ0FBQTtJQUNyQixNQUFNO0lBQ04sc0NBQTJCLENBQUE7SUFDM0IsS0FBSztJQUNMLDhCQUFtQixDQUFBO0lBQ25CLE1BQU07SUFDTixrQ0FBdUIsQ0FBQTtJQUN2QixXQUFXO0lBQ1gsZ0NBQXFCLENBQUE7SUFDckIsaUJBQWlCO0lBQ2pCLGdDQUFxQixDQUFBO0lBQ3JCLG9CQUFvQjtJQUNwQixvQ0FBeUIsQ0FBQTtJQUN6QixPQUFPO0lBQ1Asd0JBQWEsQ0FBQTtJQUNiLE9BQU87SUFDUCx3QkFBYSxDQUFBO0FBQ2pCLENBQUMsRUF6QlcsT0FBTyx1QkFBUCxPQUFPLFFBeUJsQiJ9